

import Switch from 'react-switch';
import sun from '../assets/sun.svg'
import moon from '../assets/moon.svg'

export default function ThemeSwitch(props:any) {
    const {themeToggler, theme} = props

  
    return (
      <div>
        <label>
          <Switch 
          onChange={themeToggler} 
          checked={theme === 'dark' ? true : false} 
          uncheckedIcon={false} 
          uncheckedHandleIcon={
              <div>
                  <img src={sun} alt='sun'/>
              </div>
          } 
          checkedHandleIcon={
            <div>
                <img src={moon} alt='moon'/>
            </div>
        } 
          checkedIcon={false} 
          offColor={'#202020'} 
          onColor={'#AEBBC6'}
          height={35}
          width={65}
          borderRadius={100}
          />
        </label>
      </div>
    );
}
